import {shallowEqual, useSelector} from 'react-redux';
import {Header} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/Header/Header';
import {Step} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/Step';
import {selectGuestsOfHonor, selectHostName} from '~/ViewInvitation/selectors/eventDetails';
import {selectGiftingData} from '~/ViewInvitation/selectors/gifting';
import {Button} from '~library/atoms/Button';
import {Link} from '~library/atoms/Link';
import {Picture} from '~library/atoms/Picture';
import {Typography} from '~library/atoms/Typography';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';

import './GiftIdeas.sass';

type GiftIdeasProps = {
  onCloseClick: () => void;
  variant?: boolean;
};

export const GiftIdeas = ({onCloseClick, variant}: GiftIdeasProps) => {
  const giftingData = useSelector(selectGiftingData, shallowEqual);
  const vendorName = giftingData.vendorName.toLowerCase().replace(' ', '-');
  const guestsOfHonor = useSelector(selectGuestsOfHonor);
  let giftIdeaStepTitle = useSelector(selectHostName);
  const isLargishAndUp = useIsLargishAndUp();
  const description = 'Not sure where to begin? No worries—browse Evite’s suggested gifts.';

  if (guestsOfHonor.length >= 1) {
    giftIdeaStepTitle = guestsOfHonor.join(' and ');
  }

  return (
    <Step
      header={<Header title={variant && 'Your RSVP is confirmed'} onClose={onCloseClick} />}
      footer={
        <>
          <Button
            variant="secondary"
            size="large"
            data-qa-id={`af-rsvp-gifting-${vendorName}-skip`}
            onClick={onCloseClick}
            className="rsvp-step__footer__cta"
          >
            Maybe later
          </Button>
          <Link
            as="primary"
            data-impression-tracking="true"
            data-qa-id={`af-rsvp-gifting-${vendorName}-btn`}
            href={giftingData.url}
            target="_blank"
            className="rsvp-step__footer__cta"
          >
            Find the perfect gift
          </Link>
        </>
      }
    >
      {variant && (
        <>
          <Typography
            variant={isLargishAndUp ? 'header3' : 'paragraph1'}
            color="charcoal"
            className="rsvp-brut"
            semibold
          >
            {`Start browsing gifts for ${giftIdeaStepTitle}`}
          </Typography>

          <Typography variant="paragraph2" color="charcoal">
            {description}
          </Typography>
        </>
      )}

      <Link
        href={giftingData.url}
        target="_blank"
        data-qa-id={`af-rsvp-gifting-${vendorName}-disc`}
        className="rsvp__gift-ideas__disc-container"
      >
        <Picture
          srcSet={giftingData.iconUrl}
          className="rsvp__gift-ideas__disc-image"
          alt="Vendor Image"
        />
      </Link>

      {!variant && (
        <>
          <Typography
            variant={isLargishAndUp ? 'header3' : 'header4'}
            color="charcoal"
            className="rsvp-brut"
          >
            {`Start browsing gifts for ${giftIdeaStepTitle}`}
          </Typography>

          <Typography variant="paragraph2" color="charcoal">
            {description}
          </Typography>
        </>
      )}
    </Step>
  );
};
